import { saveItem } from "./saveAPI";

const IS_SCL_DEV = window.location.hostname === "stoney-clover-dev.myshopify.com";
const IS_TOMORROW_DEV =
  window.location.hostname === "stoneycloverlane-development.myshopify.com" ||
  window.location.hostname === "127.0.0.1";

export const GIFT_WRAP_VARIANT_ID = IS_SCL_DEV
  ? "31069094150249"
  : IS_TOMORROW_DEV
  ? "40425155264701" //tomorrow variant ID
  : "4347286061086"; //production variant ID

export const enableLoadingOverlay = () => {
  const el = document.querySelector(".cart-sections-wrapper");
  if (el) el.classList.add("loading");
};

export const disableLoadingOverlay = () => {
  const el = document.querySelector(".cart-sections-wrapper");
  if (el) el.classList.remove("loading");
};

export const getCart = () => {
  return fetch(`/cart?view=ajax`).then((response) => response.json());
};

//update cart level attributes
export const updateCartAttributes = async (attributes) => {
  enableLoadingOverlay();
  const stringAttributes = JSON.stringify(attributes);
  const body = `{"attributes":${stringAttributes}}`;
  console.log(body);
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };

  const response = await fetch("/cart/update.js", options);
  disableLoadingOverlay();
  if (response.status === 200) {
    return response;
  }
  throw new Error(
    `Failed to update attributes, Shopify returned ${response.status} ${response.statusText}`
  );
};

//update line item props for one item
export const updateItemProperties = async (key, quantity, properties) => {
  enableLoadingOverlay();
  const body = `{
    "id": "${key}",
    "quantity": "${quantity}",
    "properties":${JSON.stringify(properties)}
  }`;

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  };
  const response = await fetch("/cart/change.js", options);
  disableLoadingOverlay();
  if (response.status === 200) {
    return response;
  }
  throw new Error(
    `Failed to update item properties, Shopify returned ${response.status} ${response.statusText}`
  );
};

//remove multiple items from cart then reload
export const updateItemQuantity = async (key, quantity) => {
  enableLoadingOverlay();
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: `{"updates":{"${key}": ${quantity}}}`,
  };
  const response = await fetch("/cart/update.js", options);
  disableLoadingOverlay();
  if (response.status === 200) {
    return response;
  }
  throw new Error(
    `Failed to update items, Shopify returned ${response.status} ${response.statusText}`
  );
};

//add items to cart
export const addItems = async (items) => {
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  };
  const response = await fetch("/cart/add.js", options);
  if (response.status === 200) {
    return response;
  }
  throw new Error(
    `Failed to add items to cart, Shopify returned ${response.status} ${response.statusText}`
  );
};

//remove multiple items from cart then reload
export const removeItems = async (keysToRemove) => {
  enableLoadingOverlay();
  let gifts = [];
  keysToRemove.forEach((k) => {
    const keyEl = document.querySelector(`.gift-wrap-item[data-item-key="${k}"]`);
    if (keyEl) gifts.push(keyEl.dataset.key);
  });
  let updates = [...keysToRemove, ...gifts].map((k) => `"${k}": 0`).join(",");
  console.log("updates", updates);
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: `{"updates":{${updates}}}`,
  };
  const response = await fetch("/cart/update.js", options);
  disableLoadingOverlay();
  if (response.status === 200) {
    return response;
  }
  throw new Error(
    `Failed to remove items to cart, Shopify returned ${response.status} ${response.statusText}`
  );
};

//remove multiple items from cart
export const getItems = async () => {
  const response = await fetch("/cart.js");
  if (response.status === 200) {
    return response.json();
  }
  throw new Error(
    `Failed to get items from cart, Shopify returned ${response.status} ${response.statusText}`
  );
};

//disable or enable main cart gift wrapping if individual items have wrapping
//if only one item in cart disable wrapping on individual items
export const checkGiftWrapVisibility = () => {
  const mainCartGiftWrapContainer = document.getElementById("gift-all");
  const itemCount = document.querySelectorAll(".cart-item.product-group").length;
  if (itemCount > 1) {
    document.querySelector("#cart-items-container")?.classList?.remove("only-one-item");
  }
  const itemsWithNotesCount = document.querySelectorAll(
    ".cart-items .gift-checkbox-wrapper.has-note"
  ).length;
  if (itemsWithNotesCount < 1) {
    mainCartGiftWrapContainer.classList.remove("disabled");
  } else {
    mainCartGiftWrapContainer.classList.add("disabled");
  }
};

const addGiftWrapItem = async (note, vid, key) => {
  console.log("Adding Gift Item");
  console.log(`adding with id: ${vid}`);
  const response = await addItems([
    {
      quantity: 1,
      id: GIFT_WRAP_VARIANT_ID,
      properties: {
        vid: vid,
        itemKey: key,
        giftNote: note.note,
        ...(note.to && { to: note.to }),
        ...(note.from && { from: note.from }),
      },
    },
  ]);
  return response;
};

const updateGiftWrapItem = async (note, vid, key, giftProductEl) => {
  console.log("updating Gift Item");
  const giftProductKey = giftProductEl.getAttribute("data-key");
  const response = await updateItemProperties(giftProductKey, 1, {
    giftNote: note.note,
    ...(note.to && { to: note.to }),
    ...(note.from && { from: note.from }),
    vid: vid,
    itemKey: key,
  });
  return response;
};

const removeGiftWrapItem = async (giftProductEl) => {
  const giftProductKey = giftProductEl.getAttribute("data-key");
  console.log("Removing Gift Item");
  console.log(giftProductKey);
  const response = await removeItems([giftProductKey]);
  return response;
};

//go through all the product in the cart and if they have gift wrapping enabled,
//verify a corresponding gift wrapping product exists in the cart
export const updateGiftWrappingProduct = async (forceRefresh) => {
  enableLoadingOverlay();
  let needsRefresh = forceRefresh ?? false;
  const container = document.querySelector(".cart-sections-wrapper");
  const nonGiftProductSelector = ".cart-items .cart-item:not(.saving):not(.gift-wrap-item)";
  const items = document.querySelectorAll(nonGiftProductSelector);
  const disableAllItemGifts = container.classList.contains("gifts-disabled");

  //add new notes
  for (const item of items) {
    const itemHasNote = item.querySelector(".gift-checkbox-wrapper.has-note");
    const key = item.getAttribute("data-key");
    const vid = item.getAttribute("data-vid");
    const note = {
      note: item.querySelector(".note")?.textContent,
      to: item.querySelector(".to")?.textContent,
      from: item.querySelector(".from")?.textContent,
    };
    const giftProductInCart = document.querySelector(`.gift-wrap-item[data-item-key='${key}']`);

    if (disableAllItemGifts && giftProductInCart) {
      needsRefresh = true;
      await removeGiftWrapItem(giftProductInCart);
    } else if (itemHasNote) {
      //this item has a note we need to add the gift wrap product
      //if it noes not already exist for this item
      if (giftProductInCart) {
        //note is different
        if (
          note.note !== giftProductInCart.getAttribute("data-note") ||
          note.to !== giftProductInCart.getAttribute("data-to") ||
          note.from !== giftProductInCart.getAttribute("data-from")
        ) {
          console.log("has note gift product already in cart, updating note");
          needsRefresh = true;
          await updateGiftWrapItem(note, vid, key, giftProductInCart);
          continue;
        }
        console.log("has note gift product already in cart, skipping");
        continue;
      }
      needsRefresh = true;

      await addGiftWrapItem(note, vid, key);
    } else {
      //since this item does not have a gift wrap note we need to check
      //if the gift wrap product exists for this item and if so remove it
      if (!giftProductInCart) {
        console.log("no note and gift product is not in cart, skipping");
        continue;
      }
      needsRefresh = true;
      await removeGiftWrapItem(giftProductInCart);
    }
  }
  console.log("done");
  disableLoadingOverlay();
  if (needsRefresh) {
    console.log("refreshing");
    location.reload();
  }
};

//on load: check if the gift wrap item quantity matches the number of items with gift wrap line item property
export const validateGiftWrapProductCount = () => {
  const itemsWithNotesCount = document.querySelectorAll(
    ".cart-items .cart-item:not(.saving) .gift-checkbox-wrapper.has-note"
  )?.length;
  const giftWrapItemQuantity = document.querySelectorAll(
    ".cart-item.gift-wrap-item[data-key]"
  )?.length;
  if (isNaN(itemsWithNotesCount) || isNaN(giftWrapItemQuantity)) return;
  if (itemsWithNotesCount != giftWrapItemQuantity) {
    updateGiftWrappingProduct();
  }
};

const displayMessage = (message) => {};

//save for later them remove items from cart
export const saveForLater = async (data, keys) => {
  console.log(data);
  enableLoadingOverlay();
  saveItem(data).then((response) => {
    console.log("save for later");
    console.log(response);
    if (response.ok) {
      removeItems(keys).then((res) => {
        updateGiftWrappingProduct(true);
      });
    } else {
      displayMessage("Sorry there was a problem saving this item, please try again later");
      disableLoadingOverlay();
    }
  });
};
